<script>
	import { onMount } from 'svelte';
    import { replace } from "svelte-spa-router";
import RecetasController from "../../controlador/recetasController.svelte";
import { recetaActiva } from '../../controlador/store';

    let control;
    let nombre = "",documento = "",mutual = "",afiliado = "",cuerpo = "";
    onMount(()=>{
      nombre = $recetaActiva.nombre;
      documento = $recetaActiva.documento;
      mutual = $recetaActiva.mutual;
      afiliado = $recetaActiva.afiliado;
      cuerpo = $recetaActiva.cuerpo;
    })
    async function guardar(){
        await control.crearReceta(documento,nombre,mutual,afiliado,cuerpo);
        replace('/home');
    }
</script>
<RecetasController bind:this={control}/>
<div class="container centro">
  <div class="fila">
    <input type="text" bind:value={documento} placeholder="Documento del Paciente">
  </div>
  <div class="fila">
    <input type="text" bind:value={nombre} placeholder="Nombre del Paciente">
  </div>
  <div class="fila">
    <input bind:value={mutual} type="text" placeholder="Obra Social del Paciente">
  </div>
  <div class="fila">
    <input bind:value={afiliado} type="text" placeholder="N° de Afiliado">
  </div>
  <div class="cuerpo">
    <textarea bind:value={cuerpo} placeholder="Receta..." cols="30" rows="10"></textarea>
  </div>
  <div class="fila">
    <button on:click={guardar} class="boton"><i class="ph-floppy-disk"></i> Guardar</button>
    <a class="boton" href="#/home"><i class="ph-x-circle"></i> Volver</a>
  </div>
</div>

<style>
  .centro{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .fila{
    width: 90%;
    max-width: 380px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cuerpo{
    width: 90%;
    max-width: 380px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input{
    width: 90%;
    max-width: 380px;
    margin-bottom: 10px;
    border: none;
    outline: none;
    border-radius: 10px;
    height: 30px;
    padding: 5px;
  }
  textarea{
    width: 90%;
    max-width: 380px;
    height: 300px;
    border-radius: 10px;
    border: none;
    outline: none;
    resize: none;
    padding: 5px;
  }
  .boton{
    margin: 10px;
    background: transparent;
    padding: 5px;
    color: white;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    cursor: pointer;
  }
  i{
    margin-top: 5px;
    font-size: 30px;
  }
</style>